import api from '@/api/index.js'

const journeys_by_stop_municipalities_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    LoadJourneysByStopMunicipalitiesReport({commit}, query) {
      let reqQueryStr = '';
      if (query.ignoreCache === true) {
        reqQueryStr += 'ignore-cache=t&'
      }

      if (query.period.year) {
        reqQueryStr += `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr += `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_ERROR', null)
      commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT', null)
      commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_LOADING', true)
      return api.get('reports/journeys-by-stop-municipalities?' + reqQueryStr)
        .then((response) => {
          commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT', response)
        })
        .catch((error) => {
          commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_JOURNEYS_BY_STOP_MUNICIPALITIES_REPORT_LOADING', false)
        })
    }
  },
}

export default journeys_by_stop_municipalities_report
